module.exports = __webpack_public_path__ + "img/kazunari.49c3b3ad.jpg";